import { useTheme } from '@mui/system';
import * as Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import { Button, FormHelperText, Grid, TextField } from '@mui/material';
import { MuiFileInput } from 'mui-file-input';
import ProfessionalFirestoreService from '../services/ServiceProfessional';

export const ServiceProfesionalForm = ({ formikRef, setLoading, setSnackbarData }) => {
  const theme = useTheme();

  const initialValues = {
    type: 'Servicios Profesionales',
    name: '',
    description: '',
    documentationUrl: '',
    icon: null
  };

  const resetFormHandler = () => {
    if (formikRef.current) {
      formikRef.current.resetForm({ values: initialValues });
    }
  };

  return (
    <>
      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        validationSchema={Yup.object().shape({
          name: Yup.string().required('El nombre es requerido').min(3, 'El nombre debe tener al menos 3 caracteres'),
          documentationUrl: Yup.string()
            .required('La URL de documentación es requerida')
            .url('La URL de documentación debe ser una URL válida')
        })}
        onSubmit={async (values) => {
          try {
            setLoading(true);
            let result, successMessage, errorMessage;

            if (!values.id) {
              result = await ProfessionalFirestoreService.createProfessional(values);
              successMessage = 'Recurso de servicios profesionales agregado con exito!';
              errorMessage = 'Error al agregar recurso de servicios profesionales:';
            } else {
              result = await ProfessionalFirestoreService.updateProfessional(values);
              successMessage = 'Recurso de servicios profesionales actualizado con exito!';
              errorMessage = 'Error al actualizar recurso de servicios profesionales:';
            }
            resetFormHandler();

            setSnackbarData({
              open: true,
              severity: result.error ? 'error' : 'success',
              message: result.error ? `${errorMessage} ${result.error.message}` : `${successMessage}`
            });
          } catch (error) {
            console.error(error);
            setSnackbarData({
              open: true,
              severity: 'error',
              message: 'Error inesperado'
            });
          } finally {
            setLoading(false);
          }
        }}
      >
        {({ values, errors, setFieldValue }) => (
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Field name="name" as={TextField} sx={{ ...theme.typography.customInput }} label="Nombre" variant="outlined" fullWidth />
                <FormHelperText error id="standard-weight-helper-text--register">
                  {errors.name}
                </FormHelperText>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Field
                  name="documentationUrl"
                  as={TextField}
                  sx={{ ...theme.typography.customInput }}
                  label="URL de Documentación"
                  variant="outlined"
                  fullWidth
                />
                <FormHelperText error id="standard-weight-helper-text--register">
                  {errors.documentationUrl}
                </FormHelperText>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Field
                  name="description"
                  as={TextField}
                  sx={{ ...theme.typography.customInputArea }}
                  label="Descripción"
                  variant="outlined"
                  minRows={6}
                  multiline
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Field
                  name="icon"
                  as={MuiFileInput}
                  sx={{ ...theme.typography.customInput }}
                  placeholder="Icono"
                  variant="outlined"
                  type="file"
                  inputProps={{ accept: 'image/*' }}
                  onChange={(file) => setFieldValue('icon', file)}
                  fullWidth
                />
                <FormHelperText error id="standard-weight-helper-text--register">
                  {errors.icon}
                </FormHelperText>
              </Grid>
              <Grid item xs={12} sm={12}>
                {values.id ? (
                  <>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Button type="submit" variant="contained" color="primary" fullWidth>
                          Editar
                        </Button>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Button onClick={resetFormHandler} variant="contained" style={{ backgroundColor: 'gray' }} fullWidth>
                          Cancelar Edicion
                        </Button>
                      </Grid>
                    </Grid>
                  </>
                ) : (
                  <Button type="submit" variant="contained" color="primary" fullWidth>
                    Guardar
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
};
